import { IssueCaseDoc } from '@gooduncles/gu-app-schema';
import { Card, Tag } from 'antd';
import { format, parseISO } from 'date-fns';
import { FC } from 'react';
import { issueCaseCategoryKr, issueCaseSubcategoryKr } from 'src/constants/issue.constants';

import { categoryColorMap } from 'src/utils/issue/issue-ag-grid-util';
import { issueCaseStatusBadgeMap } from 'src/utils/issue/issue-util';

import classes from './StoreSection.module.scss';

interface RecentIssueCaseCardProps {
  issueCase: IssueCaseDoc;
  isSelected: boolean;
  onSelect: () => void;
}

const RecentIssueCaseCard: FC<RecentIssueCaseCardProps> = ({ issueCase, isSelected, onSelect }) => {
  const formatDate = (dateStr: string) => {
    try {
      return format(parseISO(dateStr), 'yy/MM/dd HH:mm');
    } catch {
      return dateStr;
    }
  };

  const categoryLabel = issueCaseCategoryKr[issueCase.category] ?? issueCase.category;
  const subcategoryLabel = issueCase.subcategory
    ? issueCaseSubcategoryKr[issueCase.category]?.[issueCase.subcategory]
    : null;
  const categoryColor = categoryColorMap[issueCase.category];
  const displayText = subcategoryLabel ? `${categoryLabel} / ${subcategoryLabel}` : categoryLabel;
  const statusInfo = issueCaseStatusBadgeMap[issueCase.status];
  const tagColor = statusInfo.status === 'default' ? undefined : statusInfo.status;

  return (
    <Card
      size='small'
      className={`${classes.orderCard} ${isSelected ? classes.selected : ''}`}
      hoverable
      onClick={onSelect}
    >
      <div className={classes.orderCardContent}>
        <span className={classes.orderDate}>{formatDate(issueCase.registeredAt)}</span>
        <Tag color={tagColor}>{statusInfo.text}</Tag>
        <span style={{ color: categoryColor, fontWeight: 700, textDecoration: 'underline' }}>{displayText}</span>
        {issueCase.publicNote && (
          <span className={classes.issueMemo} title={issueCase.publicNote}>
            {issueCase.publicNote.length > 10 ? `${issueCase.publicNote.slice(0, 10)}...` : issueCase.publicNote}
          </span>
        )}
      </div>
    </Card>
  );
};

export default RecentIssueCaseCard;
